module.exports = __webpack_public_path__ + "1dcc0ff08491fd44ab3147591f0ea885.svg";